module.exports = __webpack_public_path__ + "web/img/s3.e8794a97.png";